export default [
    {
        path: '/app/seckill/list.html',
        component: (resolve) => require(['@/view/app/seckill/goods/index.vue'],resolve),
    },
    {
        path: '/app/seckill/add.html',
        component: (resolve) => require(['@/view/app/seckill/goods/add.vue'],resolve),
    },
]
